import React from 'react';
import MediaGrid from "app/app/mediaSelector/atoms/MediaGrid";
import MediaSelectorBar from "app/app/mediaSelector/partials/MediaSelectorBar";
import MediaHeader from "app/app/mediaSelector/partials/MediaHeader";

import MediaProvider from "app/app/mediaSelector/providers/MediaProvider";
import MediaSelectProvider from "app/app/mediaSelector/providers/MediaSelectProvider";
import MediaFilterProvider from "app/app/mediaSelector/providers/MediaFilterProvider";
import MediaTranslationProvider from "app/app/mediaSelector/providers/MediaTranslationProvider";

/**
 * A Media Selector component
 */

function MediaSelector(props) {

    let mediaFiles = props.media; //data from data-attribute set in php
    let bundleTitle = props.title;

    return (
        <div>
            <MediaTranslationProvider>
                <MediaProvider media={mediaFiles}>
                    <MediaFilterProvider>
                        <MediaSelectProvider>
                            <MediaHeader/>
                            <MediaGrid/>
                            <MediaSelectorBar title={bundleTitle}/>
                        </MediaSelectProvider>
                    </MediaFilterProvider>
                </MediaProvider>
            </MediaTranslationProvider>
        </div>
    );
}

export default MediaSelector;
